import {
  PM_SITIES,
  PM_CHECKLIST_QUES,
  GET_MONTHS,
  DOWNLOAD_PM_LIST,
  VIEW_PM_REPORT,
  PM_SITIES_FILTER,
  PM_SOFTWARE_AMSWER,
  PM_SOFTWARE_MAINTENANCE_SITES,
  PM_SOFTWARE_UPDATE_SITE_ASSIGNEE,
  PM_SOFTWARE_VIEW_REPORT,
  PM_SOFTWARE_REPORT_APPROVED,
  PM_SOFTWARE_REPORT_REJECTED,
  PM_SOFTWARE_POST_MAIL,
  PM_SOFTWARE_PM_LIST_DOWNLOAD, PM_SOFTWARE_PM_FILTER
} from "./type";

const initalState = {
  pmSitiesData: {},
  pmChecklistQues: {},
  maintenanceMonth: [],
  downloadPmList: {},
  pmReportData: {},
  pmdropdownList: {},
  pmSoftwareAnswerResponse:[],
  pmSoftwareSitesDetails:[],
  pmSoftwareAssigneeUpdate:[],
  pmSoftwareReportDetails:[],
  pmSoftwareReportRejectedResponse:[],
  pmSoftwareReportApprovedResponse:[],
  pmSoftwareReportPostMailResponse:[],
  pmSoftwareReportListDownload:[],
  pmSoftwareFilterResponse:[],
};

const pmSitiesReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PM_SITIES:
      return {
        ...state,
        pmSitiesData: payload,
      };
    case PM_CHECKLIST_QUES:
      return {
        ...state,
        pmChecklistQues: payload,
      };
    case GET_MONTHS:
      return {
        ...state,
        maintenanceMonth: payload,
      };
    case DOWNLOAD_PM_LIST:
      return {
        ...state,
        downloadPmList: payload,
      };
    case VIEW_PM_REPORT:
      return {
        ...state,
        pmReportData: payload,
      }
      case PM_SITIES_FILTER:
        return {
          ...state,
          pmdropdownList: payload,
        }
    case PM_SOFTWARE_AMSWER:
      return {
        ...state,
        pmSoftwareAnswerResponse: payload,
      }
    case PM_SOFTWARE_MAINTENANCE_SITES:
      return {
        ...state,
        pmSoftwareSitesDetails: payload,
      }
    case PM_SOFTWARE_UPDATE_SITE_ASSIGNEE:
      return {
        ...state,
        pmSoftwareAssigneeUpdate: payload,
      }
    case PM_SOFTWARE_VIEW_REPORT:
      return {
        ...state,
        pmSoftwareReportDetails: payload,
      }
    case PM_SOFTWARE_REPORT_APPROVED:
      return {
        ...state,
        pmSoftwareReportApprovedResponse: payload,
      }
    case PM_SOFTWARE_REPORT_REJECTED:
      return {
        ...state,
        pmSoftwareReportRejectedResponse: payload,
      }
    case PM_SOFTWARE_POST_MAIL:
      return {
        ...state,
        pmSoftwareReportPostMailResponse: payload,
      }
    case PM_SOFTWARE_PM_LIST_DOWNLOAD:
      return {
        ...state,
        pmSoftwareReportListDownload: payload,
      }
    case PM_SOFTWARE_PM_FILTER:
      return {
        ...state,
        pmSoftwareFilterResponse: payload,
      }
    default:
      return {
        ...state,
      };
  }
};

export default pmSitiesReducer;
